"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converts attributes of {@link PriceListRowDTO price list row DTO}.
 *
 * @author Radek Beran
 */


var PriceListRowDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceListRowDTOConverter, _DataObjectConverter_);

  function PriceListRowDTOConverter() {
    _classCallCheck(this, PriceListRowDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceListRowDTOConverter).apply(this, arguments));
  }

  return PriceListRowDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceListRowDTOConverter = PriceListRowDTOConverter;